import { Component, Input, OnInit } from '@angular/core';
import { State,Screen, Feature } from '../../../models/common';
import { Subject } from 'rxjs';
import { FixedSizeVirtualScrollStrategy } from '@angular/cdk/scrolling';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-screens-modal',
  templateUrl: './select-screens-modal.component.html',
  styleUrls: ['./select-screens-modal.component.scss']
})
export class SelectScreensModalComponent implements OnInit {
 IsDirty:boolean=false;
  selectScreens: boolean = true;
  //screensList: any = [];
  module:string="";
  screens: Feature[] = [];
  selectedScreens: Feature[] = [];
  action: Subject<any> = new Subject();

  @Input() public Content: any;
  constructor(public modalRef: NgbActiveModal,private modalService: NgbModal,private commonService:CommonService) { }
  ngOnInit() {
    this.screens=this.Content.screens;
  }

  

  listSorted(event:any){
    this.IsDirty=true;
  }
  ScreenChange()
  {
    //debugger;
    this.IsDirty=true;
  }
  save() {
   // if(this.IsDirty){
      let isInvalid=false;
      this.screens.forEach((item)=>{
        if(item.RecordStatus=="Inactive" && item.ISCHECKED==true)
        {
          isInvalid=true;
        }
      });
      if(isInvalid==false)
      {
        //this.commonService.SuccessBanner("Available screens details saved successfully")
    //    this.action.next(this.screens);
       // this.modalRef.dismiss();
       this.modalRef.close(this.screens);
      }
      else{
        this.commonService.ValidationBanner("Please remove deleted/inactive screen(s) to save the details")
      }
    // }
    // else{
    //   let isInvalid=false;
    //   this.screens.forEach((item)=>{
    //     if(item.RecordStatus=="Inactive" && item.ISCHECKED==true)
    //     {
    //       isInvalid=true;
    //     }
    //   });
    //   if(isInvalid==false)
    //   {
    //     //this.commonService.ValidationBanner("No changes have been performed")
    //   }
    //   else{
    //     this.commonService.ValidationBanner("Please remove deleted/inactive screen(s) to save the details")
    //   }
    //}
  }

  close(){
    this.canExit().then(x=>{
      this.modalRef.dismiss();
    });  }

    canExit() {
      if (this.IsDirty) {
        return this.commonService.CanDeactivateBanner();
      }
      else {
        return Promise.resolve(true);
      }
    }
}
